import { render, staticRenderFns } from "./DashHeader.vue?vue&type=template&id=c31ef5fc&"
import script from "./DashHeader.vue?vue&type=script&lang=js&"
export * from "./DashHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports